'use client'

import { useEffect } from 'react'
import useBlogList from '../../../../core/hook/useBlogList'
import { buildFullUrlMedia } from '../../../../core/hook/utils'
import {
  BLOG_TYPE_CELEBRITY,
  CmsBlogList,
  PAGE_SIZE_FOR_RUBRIC,
} from '../../../../domain/cmsBlogList'
import { useTranslation } from '../../../context/ConfigContext'
import StickyYearOnBlogList from './StickyYearOnBlogList'
import Image from '../../Image/Image'
import Link from '../../Link/Link'

const BlogCelebrityList = ({ initialData }: { initialData: CmsBlogList }) => {
  const { data, isLoading, fetchNextPage, isLastPage, page } = useBlogList(
    {
      blogType: BLOG_TYPE_CELEBRITY,
      pageSize: PAGE_SIZE_FOR_RUBRIC[BLOG_TYPE_CELEBRITY],
    },
    initialData,
  )
  const t = useTranslation()

  useEffect(() => {
    if (!data.items.length) {
      return
    }

    const swipers = document.querySelectorAll<HTMLElement>('.swiper.notLoaded')
    if (!swipers.length) return
  }, [data.items.length])

  return (
    <div className='Blog-list-container'>
      <StickyYearOnBlogList isReady={!isLoading} />
      <ul className='celebrities-list-container'>
        {data.items.map((item) => (
          <li
            className='celebrities-item Blog-item'
            data-year={item.date?.getFullYear() ?? null}
            data-id={item.id}
            key={item.id}>
            <Link href={item.url}>
              <div className={`swiper swiper-${item.id} notLoaded`} data-swiper-id={item.id}>
                <div className='swiper-wrapper'>
                  <div className='swiper-slide'>
                    <div className='Item--3_4'>
                      <div className='celebrities-item-image content-wrapper'>
                        <picture>
                          <Image src={buildFullUrlMedia(`/media/${item.image}`)} alt={item.name} />
                        </picture>
                      </div>
                    </div>
                  </div>
                  <div className='swiper-slide'>
                    <div className='Item--3_4'>
                      <div className='celebrities-item-image content-wrapper'>
                        <picture>
                          <Image
                            src={buildFullUrlMedia(`/media/${item.secondImage}`)}
                            alt={item.name}
                          />
                        </picture>
                      </div>
                    </div>
                  </div>
                </div>
                <div className='swiper-pagination'> </div>
              </div>
              <div className='celebrities-item-content'>
                <span className='celebrities-item-date'>{item.date?.toLocaleDateString()}</span>
                <h2 className='celebrities-item-name'>{item.name}</h2>
                <div className='celebrities-item-desc' />
              </div>
            </Link>
          </li>
        ))}
      </ul>
      {!isLastPage && (
        <div className='event-page-container-seemore'>
          <a
            href={`?page=${page}`}
            className='button'
            onClick={(e) => {
              e.preventDefault()
              e.nativeEvent.stopImmediatePropagation()
              e.currentTarget.blur()
              fetchNextPage()
            }}>
            <span className='snake' />
            <span className='snake__overlay' />
            {t('See more', {}, false)}
          </a>
        </div>
      )}
    </div>
  )
}

export default BlogCelebrityList
